import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    elementPosition: {
        marginTop: "10px"
    }
}));